import React from 'react';
import ReactDOM from 'react-dom/client';
import ComponentBasedApp from "./captain/ComponentBasedApp";
import Chain from "./captain/Chain";
import System from "./helper/system";
import { Route, Routes } from "react-router-dom";
import getSymbolFromCurrency from "currency-symbol-map/currency-symbol-map";
import RoleAndPermission from './helper/RoleAndPermission';
import '../src/styles/main.scss'
import Helper from './helper/Helper';

const RouteBasedApp = React.lazy(() => import("./captain/RouteBasedApp"));

window.mct = 'USD';
window.mcs = getSymbolFromCurrency(window.mct);
// require('./helper/modal');
System.setWindow_avUserInfo_cookie_name();

window.ltpaToken = ''

if (process.env.REACT_APP_REMOVE_HCLDX_INCLUDED_ASSETS !== 'yes') {
    loadReact(
        document.getElementById('root'),
        <RouteBasedApp />
    );
}

const c = new ComponentBasedApp().getComponent();
c.map((v) => {
    let DomID = 'react_' + Helper.camelToUnderscore(v.name);
    loadReact(
        document.getElementById(DomID),
        React.createElement(v.element)
    );
    // check and map all the component & load
    let DomName = 'React' + v.name;
    let tags = document.querySelectorAll(DomName); // Find tag from Dom (e.g. <reactUniversalSearch> set from dx )
    let chaining = [];
    if (tags.length) { // load all the compoent which are getting from DOM(Dx) // get component from our system
        Array.prototype.slice.call(tags).forEach(function (elementHere) {
            chaining.push({
                tag: elementHere,
                dom: v.element,
            })
        });
    }
    if (chaining.length) {
        chaining.map((cIn) => {
            loadReact(
                cIn.tag,
                <Routes>
                    <Route path="*" exact={true} element={
                        <>
                            {React.createElement(cIn.dom)}
                        </>
                    } />
                </Routes>
            );
        })
    }
});

async function loadReact(domElement, BaseApp) {
    RoleAndPermission.loadPermissionBasedOnAuthRole()
    if (domElement) {
        const root = ReactDOM.createRoot(domElement);
        root.render(<div className={'isolated_react_app'}>
            <Chain>
                {BaseApp}
            </Chain>
        </div>)
    }
}
